
import { mockComponents } from "@/data/mockPcComponents";
import { PcConfiguration } from "@/types/types";

/**
 * Creates an initial empty configuration state with null values
 * for all component categories
 * 
 * @returns Initial configuration object
 */
export const getInitialConfiguration = (): PcConfiguration => {
  const initialConfig: Partial<PcConfiguration> = {};
  mockComponents.forEach(category => {
    initialConfig[category.id as keyof PcConfiguration] = null;
  });
  initialConfig.fans = null;
  initialConfig.accessories = null;
  return initialConfig as PcConfiguration;
};
